// ─────────────────────────────────────────────
//  PickStep — the "now pick one" screen inside the Assign menu.
//
//  Takeover (pick a room to take) and Assign Supervising CRNA (pick a person to
//  stand with you) are the same widget: a title, a sentence saying what the pick
//  will DO, a scrollable list of choices with a primary and a muted label, an
//  empty state, and Back / Cancel. They were two copies until the second one
//  landed; one copy is what keeps the keyboard behaviour, the 44px target size
//  and the menu semantics identical between them.
//
//  ⚠️ EVERY ROW IS A `menuitem`. The arrow keys in BenchAssignFlow move between
//  whatever carries that role anywhere inside the dialog, so a list that forgot
//  it would be reachable by Tab and invisible to the arrows.
// ─────────────────────────────────────────────
import React from "react";
import st from "./benchAssignStyles";

export default function PickStep({
  title,
  sub,
  menuLabel,
  emptyText,
  items = [],
  busy = false,
  onBack,
  onCancel,
}) {
  return (
    <>
      <div style={st.title}>{title}</div>
      <div style={st.sub}>{sub}</div>
      <div style={st.takeoverList} role="menu" aria-label={menuLabel}>
        {items.length === 0 ? (
          <div style={st.empty}>{emptyText}</div>
        ) : (
          items.map((it) => (
            <button
              role="menuitem"
              type="button"
              key={it.key}
              style={st.takeoverRow}
              disabled={busy}
              onClick={it.onPick}
            >
              <span style={st.takeoverRoom}>{it.primary}</span>
              <span style={st.takeoverWho}>{it.secondary}</span>
            </button>
          ))
        )}
      </div>
      <div style={st.actions}>
        <button type="button" style={st.ghost} onClick={onBack} disabled={busy}>← Back</button>
        <button type="button" style={st.ghost} onClick={onCancel} disabled={busy}>Cancel</button>
      </div>
    </>
  );
}
